import { Stack } from 'braid-design-system';
import { useMemo } from 'react';

import type { Location2 } from 'src/types/graphql';

import { LocationGroupSubtitle } from '../ReadNextRole/LocationGroupSubtitle/LocationGroupSubtitle';
import { useSupportedCountries } from '../ReadNextRole/LocationGroupSubtitle/data';

import { groupLocations } from './utils';

export const GroupedPreferredLocations = ({
  preferredLocations,
  locationItem,
  dataAutomationSuffix,
}: {
  preferredLocations: Location2[];
  locationItem: (location: Location2) => React.ReactElement;
  dataAutomationSuffix?: string;
}) => {
  const { supportedCountries } = useSupportedCountries();
  const groupedLocations = groupLocations(
    preferredLocations,
    supportedCountries,
  );

  const isMultipleLocation =
    useMemo(
      () =>
        Object.values(groupedLocations).reduce(
          (numberOfLocation, countryLocations) =>
            numberOfLocation + countryLocations.length,
          0,
        ),
      [groupedLocations],
    ) > 1;

  return (
    <Stack
      space="medium"
      data={{ automation: `${dataAutomationSuffix}-preferred-locations` }}
    >
      {Object.keys(groupedLocations).map(
        (key) =>
          groupedLocations[key].length > 0 && (
            <Stack key={key} space="small" component="ul">
              {isMultipleLocation && (
                <LocationGroupSubtitle countryCode={key} />
              )}
              {groupedLocations[key].map((location) => locationItem(location))}
            </Stack>
          ),
      )}
    </Stack>
  );
};
